<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="user_report_filter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#user_report_filter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="full_name">
                                                {{ $t('label.full_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="full_name" name="full_name" id="full_name" v-model="query.full_name"></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="phone">
                                                {{ $t('label.phone') }}
                                            </kt-form-label>
                                            <kt-form-control ref="phone" dir="ltr" name="phone" id="phone" v-model="query.phone" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="register_date">
                                                {{ $t('reports.users.created_at') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="register_date"
                                                    name= "register_date"
                                                    v-model="query.register_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="user_level">
                                                {{ $t('reports.users.user_level') }}
                                            </kt-form-label>
                                            <select
                                                    id="user_level"
                                                    name="user_level"
                                                    v-model="query.user_level"
                                                    class="form-control kt-selectpicker"
                                            >
                                                <option
                                                        v-for="(user_level, index) in user_levels"
                                                        v-bind:key="index"
                                                        v-bind:value="user_level.value"
                                                        :selected="query.user_level === user_level.value"
                                                >
                                                    {{ user_level.name }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                            <kt-row>
                                <kt-col xs="12" sm="6" md="6">
                                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                    <button
                                            class="btn btn-success btn-wide float-right"
                                            size="md"
                                            type="button"
                                            id="export_btn"
                                            @click="exportExcel($event, query)"
                                    >
                                        {{ $t('reports.btn.export_users_to_excel') }}
                                    </button>
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
    import $ from "jquery";
    import { i18n } from '@/plugins/i18n'
    import {userCustomerClubLevel, marketingLevelStr} from '@/constants/userCustomerClubLevel'

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            exportExcel: {
                default: function(e, query) {},
                required: true,
            }
        },
        data() {
            return {
                user_levels: [
                    {
                        name: i18n.t('selectpicker.nothing_selected'),
                        value: null
                    },
                    {
                        name: marketingLevelStr.level_1,
                        value: userCustomerClubLevel.level_1,
                    },
                    {
                        name: marketingLevelStr.level_2,
                        value: userCustomerClubLevel.level_2,
                    },
                    {
                        name: marketingLevelStr.level_3,
                        value: userCustomerClubLevel.level_3,
                    },
                ],
                query: {}
            }
        },
        methods: {
            clearFromDate() {
                if(this.query.register_date) {
                    this.query.register_date = null
                }
            },
            afterDispatch() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            },
        },
        mounted() {
            this.afterDispatch()
        },
    }
</script>

<style>

</style>